import setting from "./setting.config";
import netConfig from "./net.config";
let obj = { 
  ...setting,
  ...netConfig
}
export default obj
